/**
 * Mapping between the subscription returned by the API (key-depth)
 * and the keys configured in the variable constants.jsx (values) file.
 * Structure sketch:
 * basic:
 * {
 *    suscription.status: key_in_constants,
 * }
 *
 * or complex:
 * {
 *    suscription.status: {
 *      suscription.product_type: {
 *        suscription.product_tier: key_in_constants,
 *      },
 *    },
 * }
 */
export default {
  active: {
    SSS: {
      LT: 'nimbus_free',
      PM: 'nimbus_basic',
      EN: 'nimbus_enhanced',
      PF: 'nimbus_advanced',
    },
    NSS: {
      FR: 'nimbus_free',
      BS: 'nimbus_basic',
      EN: 'nimbus_enhanced',
      AD: 'nimbus_advanced',
    },
    CIR: {
      NA: 'cirrus',
      SE: 'cirrus_se',
      SN: 'cirrus_sn',
    },
    EDG: {
      NA: 'edgon',
      SE: 'edgon_se',
      SN: 'edgon_sn',
    },
    ONP: 'on_premise',
    CON: {
      PR: 'no_consulting_access',
      DR: 'no_consulting_access',
      NA: 'cirrus',
      SE: 'cirrus',
      BS: 'cirrus',
      GD: 'cirrus',
      BR: 'cirrus',
    },
    HOS: {
      NA: 'cirrus_sn',
      SE: 'cirrus_se',
      SN: 'cirrus_sn',
      PR: 'no_consulting_access',
      ECC: 'cirrus_se',
      ECG: 'cirrus_se',
      ECS: 'cirrus_se',
      YCE: 'cirrus_se',
      YCA: 'cirrus_se',
      YCB: 'cirrus_se',
    },
    STR: 'stratus',
    else: 'else',
  },
  inactive: 'inactive_subscription',
};
